import React from 'react';

// Reusable skeleton components
const SkeletonLine = ({ width = "w-full", height = "h-4" }) => (
  <div className={`${height} ${width} bg-gray-200 rounded animate-pulse`}></div>
);

const SkeletonBlock = ({ width = "w-full", height = "h-20" }) => (
  <div className={`${height} ${width} bg-gray-200 rounded animate-pulse`}></div>
);

const DetailsPanelSkeleton = ({ isFullScreen = false }) => {
  return (
    <div className={`bg-white border-l border-gray-200 ${isFullScreen ? 'fixed inset-0 z-40' : 'w-1/2'} flex flex-col`}>
      {/* Header Skeleton */}
      <div className="p-6 border-b border-gray-200 flex justify-between items-center">
        <SkeletonLine width="w-48" height="h-6" />
        <div className="flex items-center gap-2">
          <div className="w-9 h-9 bg-gray-200 rounded animate-pulse"></div>
          <div className="w-9 h-9 bg-gray-200 rounded animate-pulse"></div>
        </div>
      </div>

      {/* Content Skeleton */}
      <div className={`flex-1 overflow-y-auto p-6 ${isFullScreen ? 'h-0' : 'max-h-[calc(100vh-100px)]'}`}>
        
        {/* Email Headers Section */}
        <div className="space-y-3 mb-6">
          {[...Array(2)].map((_, i) => (
            <div key={i} className="grid grid-cols-2 gap-4">
              <SkeletonLine width="w-20" height="h-4" />
              <SkeletonLine width="w-32" height="h-4" />
            </div>
          ))}
        </div>

        {/* Attachments Skeleton */}
        <div className="my-6">
          <div className="flex gap-4">
            {[...Array(2)].map((_, i) => (
              <div key={i} className="flex items-center gap-3 p-3 border border-gray-200 rounded-lg w-48">
                <div className="flex-shrink-0 w-8 h-8 bg-gray-200 rounded animate-pulse"></div>
                <div className="flex-1 min-w-0 space-y-1">
                  <SkeletonLine width="w-full" height="h-3" />
                  <SkeletonLine width="w-16" height="h-3" />
                </div>
                <div className="flex-shrink-0 w-4 h-4 bg-gray-200 rounded animate-pulse"></div>
              </div>
            ))}
          </div>
        </div>

        {/* Summary Details Skeleton */}
        <div className="space-y-3 mb-6">
          {[...Array(10)].map((_, i) => (
            <div key={i} className="grid grid-cols-2 gap-4">
              <SkeletonLine width="w-16" height="h-4" />
              {i === 9 ? (
                <SkeletonLine width="w-20" height="h-4" />
              ) : (
                <SkeletonLine width="w-40" height="h-4" />
              )}
            </div>
          ))}
        </div>

        {/* Table Skeleton */}
        <div className="my-6 overflow-x-auto">
          <div className="min-w-full">
            {/* Table Header */}
            <div className="bg-gray-100 border-b-2 border-gray-200">
              <div className="flex">
                {[...Array(7)].map((_, i) => (
                  <div key={i} className="px-5 py-3 flex-1 min-w-24">
                    <SkeletonLine width="w-16" height="h-3" />
                  </div>
                ))}
              </div>
            </div>
            
            {/* Table Row */}
            <div className="border-gray-200">
              <div className="flex">
                <div className="px-5 py-3 flex-1 min-w-24">
                  <SkeletonLine width="w-6" height="h-4" />
                </div>
                {[...Array(6)].map((_, i) => (
                  <div key={i} className="px-5 py-3 flex-1 min-w-24">
                    <div className="w-full h-4"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Memo Section Skeleton */}
        <div className="mb-8">
          <div className="mb-3">
            <SkeletonLine width="w-12" height="h-4" />
          </div>
          <div className="border border-gray-200 rounded-lg">
            {/* Toolbar Skeleton */}
            <div className="border-b border-gray-200 p-3">
              <div className="flex items-center gap-2">
                <SkeletonLine width="w-16" height="h-6" />
                <div className="w-6 h-6 bg-gray-200 rounded animate-pulse"></div>
                <div className="w-6 h-6 bg-gray-200 rounded animate-pulse"></div>
                <div className="w-6 h-6 bg-gray-200 rounded animate-pulse"></div>
              </div>
            </div>
            
            {/* Content Area Skeleton */}
            <div className="p-4">
              <SkeletonBlock height="h-32" />
            </div>
          </div>
        </div>
      </div>

      {/* Footer Actions Skeleton */}
      <div className="p-6 border-t border-gray-200">
        <div className="flex gap-3">
          <SkeletonBlock width="flex-1" height="h-10" />
          <SkeletonBlock width="flex-1" height="h-10" />
        </div>
      </div>
    </div>
  );
};

export default DetailsPanelSkeleton ;